import { Environment } from './environment.model';

/** Deploy IIS on-premise — portal-gestao-parkinghub.mosten.io (pipeline: MLG00125PROD). */
export const environment: Environment = {
  production: true,
  brand: 'cliente',
  deployTarget: 'MLG00125PROD',
  baseURL: 'https://api-agendamento-parkinghub-djhjcugcgtbzhfez.eastus2-01.azurewebsites.net/api/',
  sentry: {
    enabled: true,
    dsn: 'https://f7476acd56745c87a6ac52d1e57d11f4@o4511627544231936.ingest.us.sentry.io/4511829316272128',
    environment: 'production',
    release: 'parkinghubgestao-web',
  },
};
